export default {
    formatDate(dateStr) {
        const date = new Date(dateStr);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        const year = date.getFullYear();

        if (day < 10) {
            day = '0' + day;
        }

        if (month < 10) {
            month = '0' + month;
        }

        return day + '.' + month + '.' + year + 'г.';
    },

    formatDateISO(dateStr) {
        const date = new Date(dateStr);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        const year = date.getFullYear();

        if (day < 10) {
            day = '0' + day;
        }

        if (month < 10) {
            month = '0' + month;
        }

        return year + '-' + month + '-' + day;
    },

    formatDateTime(dateStr) {
        const date = new Date(dateStr);
        let hours = date.getHours();
        let minutes = date.getMinutes();

        if (hours < 10) {
            hours = '0' + hours;
        }

        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        return this.formatDate(dateStr) + ' ' + hours + ':' + minutes;
    },

    getFormatLocale() {
        return {
            months: ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септвември', 'Октомври', 'Ноември', 'Декември'],
            // MMM
            monthsShort: ['Ян', 'Фев', 'Март', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Септ', 'Окт', 'Ноем', 'Дек'],
            // dddd
            weekdays: ['Неделя', 'Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота'],
            // ddd
            weekdaysShort: ['Нед', 'Пон', 'Вт', 'Ср', 'Четв', 'Пет', 'Съб'],
            // dd
            weekdaysMin: ['Нед', 'Пон', 'Вт', 'Ср', 'Четв', 'Пет', 'Съб'],
            // first day of week
            firstDayOfWeek: 1
        }
    }
}
